"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get_first_letter = get_first_letter;
exports.lineBreaksHtml = lineBreaksHtml;
exports.currency = currency;
exports.getUrlFileName = getUrlFileName;

var _react = _interopRequireDefault(require("react"));

function isNone(value) {
  return _.isNull(value) || _.isUndefined(value) || _.isNaN(value);
}

function get_first_letter(string) {
  if (string === null || string === undefined) {
    return '';
  }

  var letters_only = string.replace(/[\W\d_]/g, '');

  if (letters_only.length > 0) {
    return letters_only.charAt(0);
  }

  return '';
}

function lineBreaksHtml(value) {
  if (isNone(value)) {
    return "";
  }

  return value.split('\n').map(function (item, key) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: key,
      dangerouslySetInnerHTML: {
        __html: item + "<br/>"
      }
    });
  });
}

function currency(value) {
  if (isNone(value)) {
    return "";
  }

  value = parseFloat(value);

  if (isNaN(value)) {
    return "";
  }

  if (parseInt(value) < value) {
    value = value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  return "$" + value;
}

function getUrlFileName(url) {
  return url.substr(url.lastIndexOf('/') + 1);
}